module.exports = __webpack_public_path__ + "static/status_cancel.03d47aba.png";